import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PublicGallery from '@/components/PublicGallery';

const Gallery = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <Header />
      <main className="pt-20">
        <PublicGallery />
      </main>
      <Footer />
    </div>
  );
};

export default Gallery;
